import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import teacher from "../../assets/image/teacher.png";
import team from "../../assets/image/team.png";
import Ourmenters from "../../assets/image/ourmenters.png";
import RebeccaSky from "../../assets/image/RebeccaSky.png";
import MarkRobinson from "../../assets/image/MarkRobinson.png";

import "./ourMentor.css";

const mentorData = [
  {
    id: 1,
    exp: "42",
    name: "Rajagopal Vuppaluri",
    role: "Mentors",
    img: Ourmenters,
  },
];

const OurMentor = ({ viewMore, viewAll }) => {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);

  // Toggle View More / View Less
  const toggleMentorView = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="our_mentor p-100">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="content">
              <h6 className="pre_heading"> Where Student Voices Matter</h6>
            </div>
          </div>

          <div className="col-lg-6 mb-4">
            <div className="content">
              <div className="comment">
                <span>
                  In an era where young voices are reshaping conversations
                  across society, Students Chronicle emerges as a vital platform
                  that amplifies the thoughts, perspectives, and experiences of
                  students from schools and colleges worldwide. This dedicated
                  space recognizes that students are not merely passive
                  recipients of education, but active thinkers, innovators, and
                  future leaders who possess unique insights on everything from
                  academic challenges and social issues to technology, culture,
                  and global affairs. By providing an accessible forum for
                  student expression, Students Chronicle bridges the gap between
                  classroom learning and real-world discourse, ensuring that the
                  next generation's perspectives are heard, valued, and
                  integrated into broader conversations that shape our
                  collective future.
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mb-4">
            <div className="content">
              <div className="comment">
                <span>
                  Students Chronicle serves as more than just a publishing
                  platform—it's a catalyst for intellectual growth, critical
                  thinking, and meaningful dialogue. Here, students discover the
                  power of their own voices while learning to articulate complex
                  ideas, engage with diverse viewpoints, and contribute to
                  important discussions that extend far beyond campus
                  boundaries. Whether sharing personal experiences, analyzing
                  current events, proposing solutions to societal challenges, or
                  exploring creative endeavors, students find in this space the
                  opportunity to influence public discourse and connect with
                  peers across different institutions and backgrounds. This
                  platform not only validates the importance of student
                  perspectives but also prepares young writers and thinkers for
                  active citizenship, fostering a generation that is confident,
                  articulate, and ready to make their mark on the world.
                </span>
              </div>
            </div>
          </div>
          <div className="col-lg-12 mb-4"></div>
        </div>

        <div className="row mt-5">
          {/* {mentorData
            .slice(0, showAll ? mentorData.length : 3) 
            .map((mentor) => (
              <div className="col-md-4" key={mentor.id}>
                <div className="team_member text-center">
                  <img src={mentor.img} alt={mentor.name} />
                  <h4>{mentor.name}</h4>
                  <p>{mentor?.exp}+ Years Experience </p> 
                  <span>{mentor.role}</span>
                </div>
              </div>
            ))} */}
        </div>

        {/* View More / View Less Button */}
        {/* {viewMore && (
          <div className="text-center mt-4">
            <button
              className="btn_secondary mx-auto"
              onClick={toggleMentorView}
            >
              {showAll ? "View Less" : "View More"}
            </button>
          </div>
        )} */}

        {/* View All Mentors Button */}
        {/* {viewAll && (
          <div className="text-center mt-3">
            <button
              className="btn_secondary mx-auto"
              onClick={() => navigate("/mentor")}
            >
              View All Mentor/Faculty
            </button>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default OurMentor;
